var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleepWell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\xCE\\xD3\\xC8_9",
    "data-name": "\\u2014\\xCE\\xD3\\xC8_9",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231300;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.57,8.62A1.06,1.06,0,0,0,31.06,8,1.08,1.08,0,0,0,30.29,8l-3,.9,2-4a1,1,0,0,0,.07-.77,1,1,0,0,0-.51-.58,1,1,0,0,0-.77-.06L24.17,4.65a1,1,0,0,0-.61.49,1,1,0,0,0-.07.78A1,1,0,0,0,24,6.5a1.08,1.08,0,0,0,.77.07l1.65-.5-2.06,4a1,1,0,0,0-.05.78,1,1,0,0,0,.53.57,1.12,1.12,0,0,0,.44.09,1,1,0,0,0,.3,0l5.31-1.6a1,1,0,0,0,.61-.48A1,1,0,0,0,31.57,8.62ZM24.63,6.09Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.06,18.22a1,1,0,0,0-.77-.06l-3,.9,2.06-4a1,1,0,0,0,.06-.77,1,1,0,0,0-.51-.58,1.08,1.08,0,0,0-.77-.07l-4,1.19a1,1,0,0,0-.6.49,1,1,0,0,0-.07.78,1,1,0,0,0,.51.58,1.1,1.1,0,0,0,.53.11l0,0,1.86-.56-2.06,4a1,1,0,0,0-.05.79,1,1,0,0,0,.53.57,1,1,0,0,0,.44.09,1,1,0,0,0,.3,0l5.31-1.6a1,1,0,0,0,.6-.48,1,1,0,0,0,.08-.78A1,1,0,0,0,30.06,18.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.33,25.55a10.66,10.66,0,0,1-11.8-12.07,10.54,10.54,0,0,1,3.18-6.24,1.26,1.26,0,0,0-.78-2.15A14.23,14.23,0,1,0,29.48,27.52a1.25,1.25,0,0,0-1.15-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepWell);
export default __webpack_public_path__ + "static/media/sleep-well.2393600c968e9c9af5563eee47d3fbdf.svg";
export { ForwardRef as ReactComponent };